<div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
  <table class="w-full table border border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden">
    <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
      <tr class="bg-gray-100">
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Sr. No.</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Product Code</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Product Name</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Product Image</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Assigned Qty</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Available Qty</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Ready Qty</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Approved Qty</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Rejected Qty</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Status</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Action</th>
      </tr>
    </thead>
    <tbody>
      <!-- Make sure your resource sends total_quantity and approved_quantity -->
      <tr *ngFor="let order of orders; let i = index" class="text-xs sm:text-sm lg:text-[15px]">
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          {{ i + 1 }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          {{ order.product_code }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          {{ order.product_name }}
        </td>
        <td class="p-3 border-r border-b border-[#D9D9D9] text-center">
          <img
            [src]="order.image_url || '/assets/images/firm/firm-img.png'"
            alt="Product Image"
            class="w-10 h-10 object-cover rounded-md border border-gray-300"
          />
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0 font-semibold">
          {{ order.quantity }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0 text-yellow-600 font-semibold">
          {{ order.ordc_available_quantity }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0 font-semibold text-blue-600">
          {{ order.ready_quantity }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0 font-semibold text-green-600">
            {{ order.approved_quantity }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0 font-semibold text-red-600">
            {{ order.rejected_quantity }}
        <td class="py-1 px-2 text-center
          {{ order.status === 'rejected' ? 'text-[#E12222]' :
             order.status === 'pending' ? 'text-yellow-600' :
             order.status === 'completed' ? 'text-[#0f7b0f]' : 'text-blue-600' }}
          border border-[#d9d9dd] border-l-0 border-b-0">
          {{ order.status | titlecase }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          <button
            (click)="openApprovalModal(order)"
            [disabled]="order.status === 'completed' || order.status === 'READY_FOR_APPROVAL'"
            [ngClass]="{
              'bg-blue-500 hover:bg-blue-700 text-amber-50': order.status === 'pending' || order.status === 'rejected' || order.status === 'PARTIAL_APPROVED',
              'bg-green-500 text-white cursor-not-allowed': order.status === 'completed',
              'bg-gray-400 text-gray-200 cursor-not-allowed': order.status === 'READY_FOR_APPROVAL'
            }"
            class="font-bold py-1 px-3 rounded text-xs transition-all duration-200"
            [title]="
              order.status === 'completed' ? 'This order is completed' :
              order.status === 'READY_FOR_APPROVAL' ? 'Approval request sent' :
              'Request for approval'
            "
          >
            {{
              order.status === 'completed' ? 'Completed' :
              order.status === 'READY_FOR_APPROVAL' ? 'Pending Approval' :
              'Request for approval'
            }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Approval Modal -->
<!-- Approval Modal -->
<div
  *ngIf="isModalOpen"
  class="fixed inset-0 z-40 flex items-center justify-center bg-black/30 backdrop-blur-sm transition-opacity duration-300 ease-in-out"
>
  <div
    class="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-2xl m-4 transform transition-all duration-500 ease-out scale-95 animate-fade-in-up"
  >
    <!-- Header -->
    <h3 class="text-2xl font-semibold mb-3 text-gray-900 text-center">
      Request Approval
    </h3>
    <p class="mb-6 text-gray-600 text-center">
      Submit quantity for product:
      <strong>{{ selectedOrder?.product_name }} ({{ selectedOrder?.product_code }})</strong>
    </p>

    <!-- Order Details -->
    <div
      class="bg-gray-50 p-4 rounded-lg mb-6 border border-gray-200 text-sm shadow-inner"
    >
      <div class="flex justify-between mb-1">
        <span>Total Quantity:</span>
        <strong>{{ selectedOrder?.quantity }}</strong>
      </div>
      <div class="flex justify-between mb-1 text-green-600">
        <span>Approved Quantity:</span>
        <strong>{{ selectedOrder?.approved_quantity }}</strong>
      </div>
      <div class="flex justify-between mb-1 text-red-600">
        <span>Rejected Quantity:</span>
        <strong>{{ selectedOrder?.rejected_quantity }}</strong>
      </div>
      <hr class="my-2" />
      <div class="flex justify-between font-bold text-gray-800">
        <span>Remaining Quantity:</span>
        <strong>{{ maxApprovableQuantity }}</strong>
      </div>
    </div>

    <!-- Form -->
    <div class="space-y-4">
      <div>
        <label
          for="quantity"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Quantity to Submit</label
        >
        <input
          type="number"
          id="quantity"
          name="quantity"
          [(ngModel)]="quantityForApproval"
          class="mt-1 no-spinner block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#c19725] focus:border-[#c19725] transition-all duration-200"
          [max]="maxApprovableQuantity"
          min="1"
          placeholder="Enter quantity"
        />
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="mt-8 flex justify-end space-x-4">
      <button
        (click)="closeModal()"
        class="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        Cancel
      </button>
      <button
        (click)="submitForApproval()"
        class="px-5 py-2.5 bg-[#c19725] text-white rounded-lg hover:bg-[#a87f1f] shadow-md transition-all duration-300 hover:scale-105"
      >
        Submit
      </button>
    </div>
  </div>
</div>
<!-- ❗ Big Center Popup for exceed quantity-->
<div
  *ngIf="errorPopupVisible"
  class="fixed inset-0 bg-transparent bg-opacity-50 flex items-center justify-center z-50"
>
  <div class="bg-black rounded-xl shadow-xl p-6 w-80 text-center animate-fadeIn">

    <h2 class="text-lg font-semibold text-red-600 mb-3">Invalid Quantity</h2>

    <p class="text-white mb-4">
      Quantity cannot exceed the remaining {{ maxApprovableQuantity }} items.
    </p>

    <button
      (click)="errorPopupVisible = false"
      class="mt-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition"
    >
      OK
    </button>

  </div>
</div>

<!-- ❗ Big Center Popup for invalid quantity-->
<div
  *ngIf="errorValidQtyPopupVisible"
  class="fixed inset-0 bg-transparent bg-opacity-50 flex items-center justify-center z-50"
>
  <div class="bg-black rounded-xl shadow-xl p-6 w-80 text-center animate-fadeIn">

    <h2 class="text-lg font-semibold text-red-600 mb-3">Invalid Quantity</h2>

    <p class="text-white mb-4">
      Please enter a valid quantity
    </p>

    <button
      (click)="errorValidQtyPopupVisible = false"
      class="mt-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition"
    >
      OK
    </button>

  </div>
</div>